import React from 'react';
import classes from '../List.module.scss';
import typography from '@ds-typography';
import cx from 'classnames';

interface ListFooterProps {
  children: React.ReactNode;
  title: string;
}
const ListGroup: React.FC<ListFooterProps> = ({
  children,
  title,
  ...props
}) => {
  return (
    <div {...props}>
      <div className={cx(typography.dsColumnHeadLine, classes.listGroupTitle)}>
        {title}
      </div>
      {children}
    </div>
  );
};

export default ListGroup;
